// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #f0f2f5;
  --surface: #ffffff;
  --surface-hover: #f2f4f7;
  --surface-unread: #eef3fb;
  --border: #e0e3e8;
  --border-hover: #c8cdd6;
  --accent: #1a73e8;
  --accent-soft: #e8f0fe;
  --accent-glow: rgba(26,115,232,0.18);
  --like: #e0245e;
  --like-soft: #fde8ef;
  --comment: #1877f2;
  --comment-soft: #e7f0fd;
  --follow: #2e7d32;
  --follow-soft: #e8f5e9;
  --order: #e65100;
  --order-soft: #fff3e0;
  --text-primary: #1c1e21;
  --text-secondary: #65676b;
  --text-muted: #a0a3a9;
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 18px;
  --shadow-sm: 0 1px 4px rgba(0,0,0,0.08);
  --shadow-md: 0 2px 12px rgba(0,0,0,0.1);
}

* {
  box-sizing: border-box;
}

.notifications-page {
  max-width: 860px;
  margin: 0 auto 60px;
  padding: 100px 16px 0;
  min-height: 100vh;
  font-family: 'DM Sans', sans-serif;
  color: var(--text-primary);
  background-color: var(--bg);
}

/* Large screens — extra breathing room */
@media (min-width: 1024px) {
  .notifications-page {
    padding-top: 110px;
  }
}

/* ── Header ── */
.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--border);
}

.notifications-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.3px;
}

.mark-all-read-btn {
  background: var(--accent-soft);
  border: 1px solid rgba(26,115,232,0.2);
  color: var(--accent);
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 100px;
  font-size: 13px;
  letter-spacing: 0.1px;
  transition: all 0.18s ease;
}

.mark-all-read-btn:hover {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
  box-shadow: 0 3px 12px var(--accent-glow);
  transform: translateY(-1px);
}

/* ── Filters ── */
.notifications-filters {
  display: flex;
  gap: 4px;
  margin-bottom: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 100px;
  padding: 4px;
  width: fit-content;
  box-shadow: var(--shadow-sm);
}

.notifications-filters button {
  background: none;
  border: none;
  padding: 7px 22px;
  font-size: 14px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  color: var(--text-secondary);
  cursor: pointer;
  border-radius: 100px;
  transition: all 0.18s ease;
  letter-spacing: 0.1px;
}

.notifications-filters button.active {
  color: #fff;
  font-weight: 600;
  background: var(--accent);
  box-shadow: 0 2px 8px var(--accent-glow);
}

.notifications-filters button.active::after {
  display: none;
}

.notifications-filters button:not(.active):hover {
  background: var(--bg);
  color: var(--text-primary);
}

/* ── List ── */
.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ── Item ── */
.notification-item {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  transition: all 0.18s ease;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  animation: slideIn 0.25s ease both;
}

@keyframes slideIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Facebook-style: blue left border for unread */
.notification-item.unread {
  background: var(--surface-unread);
  border-color: #bad3f5;
  border-left: 4px solid var(--accent);
}

.notification-item:hover {
  background: var(--surface-hover);
  border-color: var(--border-hover);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.notification-item.unread:hover {
  background: #deeafa;
  border-color: #7ab3ec;
  border-left-color: var(--accent);
}

/* ── Avatar ── */
.notification-avatar {
  position: relative;
  margin-right: 12px;
  flex-shrink: 0;
}

.notification-avatar-image,
.user-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--border);
  display: block;
  transition: border-color 0.18s;
}

.notification-item:hover .notification-avatar-image {
  border-color: var(--accent);
}

/* ── Type Icon Badge ── */
.notification-type-icon {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: white;
  border: 2px solid white;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
}

.notification-type-icon.like    { background: var(--like); }
.notification-type-icon.comment { background: var(--comment); }
.notification-type-icon.follow  { background: var(--follow); }
.notification-type-icon.order   { background: var(--order); }

/* ── Content ── */
.notification-content {
  flex: 1 1;
  min-width: 0;
}

.notification-text {
  font-size: 14.5px;
  color: var(--text-primary);
  line-height: 1.5;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 3px;
}

.username {
  font-weight: 700;
  color: var(--text-primary);
}

.comment-preview {
  color: var(--text-secondary);
  font-style: italic;
  font-size: 13px;
}

.notification-time {
  color: var(--text-muted);
  font-size: 12px;
  margin-left: 4px;
}

/* ── Meta / Timestamp ── */
.notification-meta {
  margin-top: 4px;
}

.timestamp {
  font-family: 'DM Mono', monospace;
  font-size: 11.5px;
  color: var(--accent);
  font-weight: 500;
  letter-spacing: 0.2px;
}

.notification-item.read .timestamp {
  color: var(--text-muted);
}

/* ── Follow notification layout ── */
.notification-message.follow-notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

/* ── Preview thumbnail ── */
.notification-preview {
  margin-left: 14px;
  flex-shrink: 0;
}

.post-thumbnail {
  width: 46px;
  height: 46px;
  border-radius: var(--radius-sm);
  object-fit: cover;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.text-preview {
  background: var(--bg);
  border: 1px solid var(--border);
  padding: 6px 10px;
  border-radius: var(--radius-sm);
  font-size: 12px;
  color: var(--text-secondary);
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Unread blue dot ── */
.notification-item.unread::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background: var(--accent);
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 6px var(--accent-glow);
  animation: pulse 2.2s infinite;
}

/* Hide dot when action button exists */
.notification-item.unread:has(.notification-actions)::after {
  display: none;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }
  50%       { opacity: 0.6; transform: translateY(-50%) scale(1.35); }
}

/* ── Mark read button ── */
.notification-actions {
  margin-left: 10px;
  flex-shrink: 0;
}

.mark-read-btn {
  background: var(--accent-soft);
  border: 1px solid rgba(26,115,232,0.2);
  color: var(--accent);
  cursor: pointer;
  font-size: 14px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.18s ease;
}

.mark-read-btn:hover {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
  box-shadow: 0 2px 8px var(--accent-glow);
  transform: scale(1.1);
}

/* ── Follow back buttons ── */
.follow-back-button {
  background: var(--accent);
  border: none;
  color: #fff;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 18px;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 2px 8px var(--accent-glow);
  white-space: nowrap;
}

.follow-back-button:hover {
  background: #1558b0;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px var(--accent-glow);
}

.following-button {
  background: var(--bg);
  border: 1px solid var(--border);
  color: var(--text-secondary);
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 13px;
  padding: 7px 18px;
  border-radius: 100px;
  cursor: default;
  white-space: nowrap;
}

/* ── Notification icons ── */
.notification-icon.like    { color: var(--like); }
.notification-icon.comment { color: var(--comment); }
.notification-icon.follow  { color: var(--follow); }
.notification-icon.order   { color: var(--order); }

/* ── States: Loading / Error / Empty ── */
.notifications-loading,
.notifications-error,
.no-notifications {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.loading-spinner {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid var(--accent-soft);
  border-top-color: var(--accent);
  animation: spin 0.75s linear infinite;
  margin-bottom: 14px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.notifications-loading p,
.notifications-error p {
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0;
}

.no-notifications-icon {
  font-size: 46px;
  margin-bottom: 14px;
  color: var(--text-muted);
}

.no-notifications h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 6px;
}

.no-notifications p {
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0;
}

.notifications-error button {
  margin-top: 16px;
  padding: 9px 22px;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.18s ease;
  box-shadow: 0 3px 10px var(--accent-glow);
}

.notifications-error button:hover {
  background: #1558b0;
  transform: translateY(-1px);
  box-shadow: 0 5px 16px var(--accent-glow);
}

/* ── Stagger animation ── */
.notification-item:nth-child(1)  { animation-delay: 0.03s; }
.notification-item:nth-child(2)  { animation-delay: 0.06s; }
.notification-item:nth-child(3)  { animation-delay: 0.09s; }
.notification-item:nth-child(4)  { animation-delay: 0.12s; }
.notification-item:nth-child(5)  { animation-delay: 0.15s; }
.notification-item:nth-child(6)  { animation-delay: 0.18s; }
.notification-item:nth-child(7)  { animation-delay: 0.21s; }
.notification-item:nth-child(8)  { animation-delay: 0.24s; }
.notification-item:nth-child(9)  { animation-delay: 0.27s; }
.notification-item:nth-child(10) { animation-delay: 0.30s; }
/* ── Responsive ── */
@media (max-width: 768px) {
  .notifications-page {
    padding-top: 80px;
    padding-left: 12px;
    padding-right: 12px;
  }

  .notifications-header h2 {
    font-size: 20px;
  }

  .notifications-filters {
    width: 100%;
    justify-content: space-between;
  }

  .notifications-filters button {
    padding: 7px 14px;
    font-size: 13px;
    flex: 1 1;
    text-align: center;
  }

  .notification-item {
    padding: 10px 12px;
  }

  .notification-avatar-image,
  .user-avatar {
    width: 38px;
    height: 38px;
  }

  .notification-text {
    font-size: 13.5px;
  }

  .follow-back-button,
  .following-button {
    padding: 6px 14px;
    font-size: 12px;
  }

  .post-thumbnail {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .notifications-page {
    padding-top: 75px;
    padding-left: 8px;
    padding-right: 8px;
  }

  .mark-all-read-btn {
    padding: 7px 12px;
    font-size: 12px;
  }

  .notification-avatar-image,
  .user-avatar {
    width: 34px;
    height: 34px;
  }

  .notification-text {
    font-size: 13px;
  }

  .notification-item.unread::after {
    right: 10px;
    width: 8px;
    height: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Notifications.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,yCAAyC;AACzC;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,gDAAgD;AAChD;EACE,iCAAiC;EACjC,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,kCAAkC,uBAAuB,EAAE;AAC3D,kCAAkC,0BAA0B,EAAE;AAC9D,kCAAkC,yBAAyB,EAAE;AAC7D,kCAAkC,wBAAwB,EAAE;;AAE5D,kBAAkB;AAClB;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA;EACE,WAAW,UAAU,EAAE,oCAAoC,EAAE;EAC7D,YAAY,YAAY,EAAE,uCAAuC,EAAE;AACrE;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B,6BAA6B,kBAAkB,EAAE;AACjD,6BAA6B,qBAAqB,EAAE;AACpD,6BAA6B,oBAAoB,EAAE;AACnD,6BAA6B,mBAAmB,EAAE;;AAElD,0CAA0C;AAC1C;;;EAGE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,4BAA4B;AAC5B,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;AAC3D,qBAAqB;AACrB;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,SAAO;IACP,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');\n\n:root {\n  --bg: #f0f2f5;\n  --surface: #ffffff;\n  --surface-hover: #f2f4f7;\n  --surface-unread: #eef3fb;\n  --border: #e0e3e8;\n  --border-hover: #c8cdd6;\n  --accent: #1a73e8;\n  --accent-soft: #e8f0fe;\n  --accent-glow: rgba(26,115,232,0.18);\n  --like: #e0245e;\n  --like-soft: #fde8ef;\n  --comment: #1877f2;\n  --comment-soft: #e7f0fd;\n  --follow: #2e7d32;\n  --follow-soft: #e8f5e9;\n  --order: #e65100;\n  --order-soft: #fff3e0;\n  --text-primary: #1c1e21;\n  --text-secondary: #65676b;\n  --text-muted: #a0a3a9;\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 18px;\n  --shadow-sm: 0 1px 4px rgba(0,0,0,0.08);\n  --shadow-md: 0 2px 12px rgba(0,0,0,0.1);\n}\n\n* {\n  box-sizing: border-box;\n}\n\n.notifications-page {\n  max-width: 860px;\n  margin: 0 auto 60px;\n  padding: 100px 16px 0;\n  min-height: 100vh;\n  font-family: 'DM Sans', sans-serif;\n  color: var(--text-primary);\n  background-color: var(--bg);\n}\n\n/* Large screens — extra breathing room */\n@media (min-width: 1024px) {\n  .notifications-page {\n    padding-top: 110px;\n  }\n}\n\n/* ── Header ── */\n.notifications-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--border);\n}\n\n.notifications-header h2 {\n  font-size: 24px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n.mark-all-read-btn {\n  background: var(--accent-soft);\n  border: 1px solid rgba(26,115,232,0.2);\n  color: var(--accent);\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 100px;\n  font-size: 13px;\n  letter-spacing: 0.1px;\n  transition: all 0.18s ease;\n}\n\n.mark-all-read-btn:hover {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n  box-shadow: 0 3px 12px var(--accent-glow);\n  transform: translateY(-1px);\n}\n\n/* ── Filters ── */\n.notifications-filters {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 18px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 100px;\n  padding: 4px;\n  width: fit-content;\n  box-shadow: var(--shadow-sm);\n}\n\n.notifications-filters button {\n  background: none;\n  border: none;\n  padding: 7px 22px;\n  font-size: 14px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 500;\n  color: var(--text-secondary);\n  cursor: pointer;\n  border-radius: 100px;\n  transition: all 0.18s ease;\n  letter-spacing: 0.1px;\n}\n\n.notifications-filters button.active {\n  color: #fff;\n  font-weight: 600;\n  background: var(--accent);\n  box-shadow: 0 2px 8px var(--accent-glow);\n}\n\n.notifications-filters button.active::after {\n  display: none;\n}\n\n.notifications-filters button:not(.active):hover {\n  background: var(--bg);\n  color: var(--text-primary);\n}\n\n/* ── List ── */\n.notifications-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n/* ── Item ── */\n.notification-item {\n  display: flex;\n  align-items: center;\n  padding: 12px 14px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  transition: all 0.18s ease;\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  animation: slideIn 0.25s ease both;\n}\n\n@keyframes slideIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Facebook-style: blue left border for unread */\n.notification-item.unread {\n  background: var(--surface-unread);\n  border-color: #bad3f5;\n  border-left: 4px solid var(--accent);\n}\n\n.notification-item:hover {\n  background: var(--surface-hover);\n  border-color: var(--border-hover);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.notification-item.unread:hover {\n  background: #deeafa;\n  border-color: #7ab3ec;\n  border-left-color: var(--accent);\n}\n\n/* ── Avatar ── */\n.notification-avatar {\n  position: relative;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.notification-avatar-image,\n.user-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--border);\n  display: block;\n  transition: border-color 0.18s;\n}\n\n.notification-item:hover .notification-avatar-image {\n  border-color: var(--accent);\n}\n\n/* ── Type Icon Badge ── */\n.notification-type-icon {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  color: white;\n  border: 2px solid white;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.15);\n}\n\n.notification-type-icon.like    { background: var(--like); }\n.notification-type-icon.comment { background: var(--comment); }\n.notification-type-icon.follow  { background: var(--follow); }\n.notification-type-icon.order   { background: var(--order); }\n\n/* ── Content ── */\n.notification-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.notification-text {\n  font-size: 14.5px;\n  color: var(--text-primary);\n  line-height: 1.5;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 3px;\n}\n\n.username {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.comment-preview {\n  color: var(--text-secondary);\n  font-style: italic;\n  font-size: 13px;\n}\n\n.notification-time {\n  color: var(--text-muted);\n  font-size: 12px;\n  margin-left: 4px;\n}\n\n/* ── Meta / Timestamp ── */\n.notification-meta {\n  margin-top: 4px;\n}\n\n.timestamp {\n  font-family: 'DM Mono', monospace;\n  font-size: 11.5px;\n  color: var(--accent);\n  font-weight: 500;\n  letter-spacing: 0.2px;\n}\n\n.notification-item.read .timestamp {\n  color: var(--text-muted);\n}\n\n/* ── Follow notification layout ── */\n.notification-message.follow-notification {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n/* ── Preview thumbnail ── */\n.notification-preview {\n  margin-left: 14px;\n  flex-shrink: 0;\n}\n\n.post-thumbnail {\n  width: 46px;\n  height: 46px;\n  border-radius: var(--radius-sm);\n  object-fit: cover;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.text-preview {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  padding: 6px 10px;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  color: var(--text-secondary);\n  max-width: 120px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Unread blue dot ── */\n.notification-item.unread::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  background: var(--accent);\n  border-radius: 50%;\n  border: 2px solid white;\n  box-shadow: 0 0 6px var(--accent-glow);\n  animation: pulse 2.2s infinite;\n}\n\n/* Hide dot when action button exists */\n.notification-item.unread:has(.notification-actions)::after {\n  display: none;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; transform: translateY(-50%) scale(1); }\n  50%       { opacity: 0.6; transform: translateY(-50%) scale(1.35); }\n}\n\n/* ── Mark read button ── */\n.notification-actions {\n  margin-left: 10px;\n  flex-shrink: 0;\n}\n\n.mark-read-btn {\n  background: var(--accent-soft);\n  border: 1px solid rgba(26,115,232,0.2);\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 14px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: all 0.18s ease;\n}\n\n.mark-read-btn:hover {\n  background: var(--accent);\n  color: #fff;\n  border-color: var(--accent);\n  box-shadow: 0 2px 8px var(--accent-glow);\n  transform: scale(1.1);\n}\n\n/* ── Follow back buttons ── */\n.follow-back-button {\n  background: var(--accent);\n  border: none;\n  color: #fff;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 7px 18px;\n  border-radius: 100px;\n  cursor: pointer;\n  transition: all 0.18s ease;\n  box-shadow: 0 2px 8px var(--accent-glow);\n  white-space: nowrap;\n}\n\n.follow-back-button:hover {\n  background: #1558b0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 14px var(--accent-glow);\n}\n\n.following-button {\n  background: var(--bg);\n  border: 1px solid var(--border);\n  color: var(--text-secondary);\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  font-size: 13px;\n  padding: 7px 18px;\n  border-radius: 100px;\n  cursor: default;\n  white-space: nowrap;\n}\n\n/* ── Notification icons ── */\n.notification-icon.like    { color: var(--like); }\n.notification-icon.comment { color: var(--comment); }\n.notification-icon.follow  { color: var(--follow); }\n.notification-icon.order   { color: var(--order); }\n\n/* ── States: Loading / Error / Empty ── */\n.notifications-loading,\n.notifications-error,\n.no-notifications {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n  text-align: center;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.loading-spinner {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 3px solid var(--accent-soft);\n  border-top-color: var(--accent);\n  animation: spin 0.75s linear infinite;\n  margin-bottom: 14px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.notifications-loading p,\n.notifications-error p {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin: 0;\n}\n\n.no-notifications-icon {\n  font-size: 46px;\n  margin-bottom: 14px;\n  color: var(--text-muted);\n}\n\n.no-notifications h3 {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 6px;\n}\n\n.no-notifications p {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin: 0;\n}\n\n.notifications-error button {\n  margin-top: 16px;\n  padding: 9px 22px;\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.18s ease;\n  box-shadow: 0 3px 10px var(--accent-glow);\n}\n\n.notifications-error button:hover {\n  background: #1558b0;\n  transform: translateY(-1px);\n  box-shadow: 0 5px 16px var(--accent-glow);\n}\n\n/* ── Stagger animation ── */\n.notification-item:nth-child(1)  { animation-delay: 0.03s; }\n.notification-item:nth-child(2)  { animation-delay: 0.06s; }\n.notification-item:nth-child(3)  { animation-delay: 0.09s; }\n.notification-item:nth-child(4)  { animation-delay: 0.12s; }\n.notification-item:nth-child(5)  { animation-delay: 0.15s; }\n.notification-item:nth-child(6)  { animation-delay: 0.18s; }\n.notification-item:nth-child(7)  { animation-delay: 0.21s; }\n.notification-item:nth-child(8)  { animation-delay: 0.24s; }\n.notification-item:nth-child(9)  { animation-delay: 0.27s; }\n.notification-item:nth-child(10) { animation-delay: 0.30s; }\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .notifications-page {\n    padding-top: 80px;\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .notifications-header h2 {\n    font-size: 20px;\n  }\n\n  .notifications-filters {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .notifications-filters button {\n    padding: 7px 14px;\n    font-size: 13px;\n    flex: 1;\n    text-align: center;\n  }\n\n  .notification-item {\n    padding: 10px 12px;\n  }\n\n  .notification-avatar-image,\n  .user-avatar {\n    width: 38px;\n    height: 38px;\n  }\n\n  .notification-text {\n    font-size: 13.5px;\n  }\n\n  .follow-back-button,\n  .following-button {\n    padding: 6px 14px;\n    font-size: 12px;\n  }\n\n  .post-thumbnail {\n    width: 40px;\n    height: 40px;\n  }\n}\n\n@media (max-width: 480px) {\n  .notifications-page {\n    padding-top: 75px;\n    padding-left: 8px;\n    padding-right: 8px;\n  }\n\n  .mark-all-read-btn {\n    padding: 7px 12px;\n    font-size: 12px;\n  }\n\n  .notification-avatar-image,\n  .user-avatar {\n    width: 34px;\n    height: 34px;\n  }\n\n  .notification-text {\n    font-size: 13px;\n  }\n\n  .notification-item.unread::after {\n    right: 10px;\n    width: 8px;\n    height: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
